import { render, staticRenderFns } from "./AddVideoCard.vue?vue&type=template&id=00a3f244&scoped=true&"
import script from "./AddVideoCard.vue?vue&type=script&lang=js&"
export * from "./AddVideoCard.vue?vue&type=script&lang=js&"
import style0 from "./AddVideoCard.vue?vue&type=style&index=0&id=00a3f244&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a3f244",
  null
  
)

export default component.exports